export const getLogo = () =>
  isMobio360Plus()
    ? "./img/logo-mobio360plus.png"
    : isAfricatv()
    ? "./img/africatv_logo.svg"
    : isVibe360()
    ? "./img/vibe360_logo.svg"
    : isMobioplus()
    ? "/img/mobioplus_logo.svg"
    : "./img/logo.png";

export const getText = () =>
  isMobio360Plus()
    ? "Mobio360+"
    : isAfricatv()
    ? "Africatv"
    : isVibe360()
    ? "vibe360"
    : isMobioplus
    ? "Mobioplus"
    : "Mobio360";

export const isMobio360Plus = () => {
  return window.location.hostname.includes("mobio360plus");
  // || window.location.hostname.includes('localhost')
};

export const isAfricatv = () => {
  return window.location.hostname.includes("africatv");
  // || window.location.hostname.includes('localhost')
};
export const isMobioplus = () => {
  return window.location.hostname.includes("plus");
  //|| window.location.hostname.includes("localhost")
};

export const isVibe360 = () => {
  return window.location.hostname.includes("vibe360");
  // || window.location.hostname.includes('localhost')
};



// WEBPACK FOOTER //
// ./src/constants/multiDomains.js